import {useQuery} from 'react-query'
import {UserEditModalForm} from './UserEditModalForm'
import {isNotEmpty} from '../../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import axios from 'axios'
 
const UserEditModalFormWrapper = () => {
   const {itemIdForUpdate, setItemIdForUpdate} = useListView()
   
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: user,
    error,
  } = useQuery(
    `roleById`,
    async () => {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/admin/get-role/${itemIdForUpdate}`);
      return response.data;
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return <UserEditModalForm isUserLoading={isLoading} user={{id: undefined}} />
  }

  if (!isLoading && !error && user) {
    return <UserEditModalForm isUserLoading={isLoading} user={user} />
  }
  else {
    return (
      <div className="d-flex justify-content-center">
        <div style={{width: '3rem', height: '3rem'}} className="spinner-border" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    )
  }

 
}

export {UserEditModalFormWrapper}
